import type { GiftCategory, RelationType, MessageType, ResponseType, ReferidoPhase } from '@/types';

// ========================================
// Ciudades Predefinidas - Inland Empire y Sur de California
// ========================================

export const CITIES: string[] = [
  // Inland Empire - Riverside County
  'Riverside',
  'Moreno Valley',
  'Corona',
  'Temecula',
  'Murrieta',
  'Menifee',
  'Hemet',
  'Perris',
  'Lake Elsinore',
  'Indio',
  'Palm Desert',
  'Palm Springs',
  'Cathedral City',
  'La Quinta',
  'Coachella',
  'San Jacinto',
  'Beaumont',
  'Banning',
  'Wildomar',
  'Eastvale',
  'Jurupa Valley',
  'Norco',
  'Romoland',
  'Mead Valley',
  'Woodcrest',
  'Glen Avon',
  'Rubidoux',
  'Pedley',
  'Homeland',
  'Nuevo',
  'Winchester',
  'French Valley',
  'Anza',
  'Aguanga',
  'Desert Hot Springs',

  // Inland Empire - San Bernardino County
  'San Bernardino',
  'Fontana',
  'Ontario',
  'Rancho Cucamonga',
  'Victorville',
  'Rialto',
  'Hesperia',
  'Chino',
  'Chino Hills',
  'Upland',
  'Apple Valley',
  'Redlands',
  'Colton',
  'Highland',
  'Yucaipa',
  'Adelanto',
  'Loma Linda',
  'Montclair',
  'Barstow',
  'Grand Terrace',
  'Twentynine Palms',
  'Yucca Valley',
  'Big Bear Lake',
  'Bloomington',
  'Muscoy',
  'Mentone',

  // Los Angeles County
  'Los Angeles',
  'Long Beach',
  'Santa Clarita',
  'Glendale',
  'Lancaster',
  'Palmdale',
  'Pomona',
  'Torrance',
  'Pasadena',
  'El Monte',
  'Downey',
  'Inglewood',
  'West Covina',
  'Norwalk',
  'Burbank',
  'Compton',
  'South Gate',
  'Carson',
  'Santa Monica',
  'Whittier',
  'Hawthorne',
  'Alhambra',
  'Lakewood',
  'Bellflower',
  'Baldwin Park',
  'Lynwood',
  'Redondo Beach',
  'Pico Rivera',
  'Montebello',
  'Monterey Park',

  // Orange County
  'Anaheim',
  'Santa Ana',
  'Irvine',
  'Huntington Beach',
  'Garden Grove',
  'Orange',
  'Fullerton',
  'Costa Mesa',
  'Mission Viejo',
  'Westminster',
  'Newport Beach',
  'Buena Park',
  'Lake Forest',
  'Tustin',
  'Yorba Linda',
  'San Clemente',
  'Laguna Niguel',
  'La Habra',
  'Fountain Valley',
  'Placentia',

  // San Diego County
  'San Diego',
  'Chula Vista',
  'Oceanside',
  'Escondido',
  'Carlsbad',
  'El Cajon',
  'Vista',
  'San Marcos',
  'Encinitas',
  'National City',
  'La Mesa',
  'Santee',
  'Poway',
  'Imperial Beach',
];

// ========================================
// Regalos (premio inmediato por 20+ contactos)
// ========================================

export interface GiftOption {
  id: GiftCategory;
  name: string;
  image: string;
}

export const GIFTS: GiftOption[] = [
  {
    id: 1,
    name: '6 Servidores',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599851/6-servidores_f4eb7i.jpg',
  },
  {
    id: 2,
    name: 'Tabla de Bambú',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599851/tablas_quu3ln.jpg',
  },
  {
    id: 3,
    name: 'Hervidor 1Qt',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599851/hervidor_rddcu7.jpg',
  },
  {
    id: 4,
    name: 'Hacha',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599850/hacha_fpgrlv.jpg',
  },
  {
    id: 5,
    name: 'Cafetera Espresso',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599850/espresso_vihjpi.jpg',
  },
  {
    id: 6,
    name: '3 Bowls',
    image: 'https://res.cloudinary.com/ddpbqxyrw/image/upload/v1780599850/bolws_bovuf3.webp',
  },
];

export const GIFT_MAP: Record<GiftCategory, string> = {
  1: '6 Servidores',
  2: 'Tabla de Bambú',
  3: 'Hervidor 1Qt',
  4: 'Hacha',
  5: 'Cafetera Espresso',
  6: '3 Bowls',
};

// ========================================
// Tipos de Relación
// ========================================

export interface RelationOption {
  value: RelationType;
  label: string;
}

export const RELATIONS: RelationOption[] = [
  { value: 'FAMILIAR', label: 'Familiar' },
  { value: 'AMIGO', label: 'Amigo' },
  { value: 'EX_COMPANERO_TRABAJO', label: 'Ex compañero de trabajo' },
  { value: 'CONOCIDO', label: 'Conocido' },
  { value: 'PAREJA', label: 'Pareja' },
];

// ========================================
// Tipos de Mensaje Enviado
// ========================================

export interface MessageTypeOption {
  value: MessageType;
  label: string;
}

export const MESSAGE_TYPES: MessageTypeOption[] = [
  { value: 'SMS', label: 'SMS' },
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'IMESSAGE', label: 'iMessage' },
  { value: 'CITA_INSTANTANEA', label: 'Llamada instantánea' },
];

// ========================================
// Respuestas del Referido
// ========================================

export interface ResponseOption {
  value: ResponseType;
  label: string;
}

export const RESPONSES: ResponseOption[] = [
  { value: 'OK_GRACIAS', label: 'Dijo OK, gracias ✅' },
  { value: 'PREGUNTO_QUIEN_ES', label: 'Preguntó quién es 🤔' },
  { value: 'NO_RESPONDIO', label: 'No ha respondido ⏳' },
  { value: 'CITA_INSTANTANEA', label: 'Cita Instantánea 🤝' },
];

// ========================================
// Fases de Captura de Referidos
// ========================================

export interface PhaseOption {
  key: ReferidoPhase;
  label: string;
  shortLabel: string;
}

export const REFERIDO_PHASES: PhaseOption[] = [
  { key: 'names', label: 'Nombres', shortLabel: '1' },
  { key: 'messages', label: 'Mensajes', shortLabel: '2' },
  { key: 'phones', label: 'Teléfonos', shortLabel: '3' },
  { key: 'details', label: 'Detalles', shortLabel: '4' },
  { key: 'responses', label: 'Respuestas', shortLabel: '5' },
];

// ========================================
// Plantilla de Mensaje para Referidor
// ========================================

// Fallback estático (por si se usa sin datos). El mensaje real se arma con
// buildReferidoMessage, que mete el regalo ganado y el nombre del asesor.
export const REFERIDO_MESSAGE_TEMPLATE =
  'Hola XXX, mira el regalo que me gané 🎁\nPensé en ti y te inscribí en el mismo programa de regalos.\nMi amigo te va a llamar de mi parte, recíbelo con confianza. Te va a gustar.';

/**
 * Arma el mensaje que el referidor envía a sus contactos.
 * - regalo: el regalo que ganó el referidor (uno de los 6). Opcional.
 * - asesor: el nombre de quien captura (asesor logueado). Opcional.
 */
export function buildReferidoMessage(opts: { regalo?: string; asesor?: string }): string {
  const regalo = opts.regalo?.trim();
  const asesor = opts.asesor?.trim();

  const linea1 = regalo
    ? `Hola XXX, mira el regalo que me gané: ${regalo} 🎁`
    : 'Hola XXX, mira el regalo que me gané 🎁';

  const linea3 = asesor
    ? `Mi amigo ${asesor} te va a llamar de mi parte, recíbelo con confianza. Te va a gustar.`
    : 'Mi amigo te va a llamar de mi parte, recíbelo con confianza. Te va a gustar.';

  return [
    linea1,
    'Pensé en ti y te inscribí en el mismo programa de regalos.',
    linea3,
  ].join('\n');
}

// ========================================
// Mensajes Motivacionales
// ========================================

export const MOTIVATIONAL_MESSAGES = {
  morning: [
    '¡Buen día! Es hora de conquistar el día.',
    '¡Arriba! Cada referido cuenta.',
    'Un nuevo día, nuevas oportunidades.',
  ],
  milestone: {
    10: '¡Excelente! 10 referidos y contando.',
    25: '¡Increíble! 25 referidos. ¡Sigue así!',
    50: '¡WOW! 50 referidos. ¡Eres imparable!',
    100: '¡SUPER VENDEDOR! 100 referidos alcanzados.',
  },
  encouragement: [
    'Cada referido te acerca a tu meta.',
    'Tu esfuerzo vale la pena.',
    'Más referidos = Más citas = Más ventas.',
    '¡Tú puedes! Solo un referido más.',
  ],
  progress: {
    low: 'Todavía hay tiempo. ¡Vamos con todo!',
    medium: '¡Vas bien! Ya llevas la mitad.',
    high: '¡Casi llegas! Solo un poco más.',
    complete: '¡META CUMPLIDA! Eres un campeón.',
  },
};

// ========================================
// Configuración de Validaciones
// ========================================

export const VALIDATION_RULES = {
  referidor: {
    nombre_completo: {
      minLength: 4,
      maxLength: 100,
      required: true,
    },
    telefono: {
      length: 10,
      required: true,
    },
    direccion: {
      maxLength: 200,
      required: false,
    },
    regalo_detalle: {
      maxLength: 100,
      required: true,
    },
    firma_digital: {
      required: true,
    },
  },
  referido: {
    nombre: {
      minLength: 2,
      maxLength: 50,
      required: true,
    },
    apellido: {
      minLength: 2,
      maxLength: 50,
      required: true,
    },
    telefono: {
      length: 10,
      required: true,
    },
    ciudad: {
      maxLength: 100,
      required: true,
    },
    dato_extra: {
      maxLength: 300,
      required: false,
    },
  },
};

// ========================================
// Configuración de Sincronización
// ========================================

export const SYNC_CONFIG = {
  autoSyncInterval: 30000, // 30 segundos
  maxRetries: 5,
  retryBackoffMultiplier: 2,
  maxRetryDelay: 300000, // 5 minutos
  batchSize: 10,
};

// ========================================
// Columnas de Google Sheets
// ========================================

export const SHEET_COLUMNS = {
  // Datos del Referidor (columnas B-H)
  FECHA_REGISTRO: 'B',
  ASESOR: 'C',
  NOMBRE_CLIENTE: 'D',
  TELEFONO_CLIENTE: 'E',
  DIRECCION_CLIENTE: 'F',
  REGALO: 'G',
  CONTACTO_CLIENTE: 'H',

  // Datos del Referido (columnas J-T)
  CONTACTO_REFERIDO: 'J',
  NOMBRE_REFERIDO: 'K',
  APELLIDO_REFERIDO: 'L',
  TELEFONO_REFERIDO: 'M',
  CIUDAD: 'N',
  RELACION: 'O',
  TRABAJA: 'P',
  DATO_EXTRA: 'Q',
  DUENO: 'R',
  ENVIO_SMS: 'S',
  PRIORIDAD: 'T',
};

// ========================================
// Metas
// ========================================

export const GOALS = {
  daily: 30,
  weekly: 150,
  monthly: 600,
};
